import * as React from "react";

function IcProductDuotoneTrainFill(props) {
  const {
    accentColor: accent = "#0194F3",
    color = "#687176",
    width = 24,
    height = 24,
    title,
    titleId,
  } = props;
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      data-id="IcProductDuotoneTrainFill"
      aria-labelledby={titleId}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.00003 17L2.39894 20.7645C1.91765 21.1583 1.88158 21.8816 2.3213 22.3213C2.7057 22.7057 3.3198 22.7335 3.73743 22.3855L9.00003 18L7.00003 17Z"
        fill={accent}
      />
      <path d="M4.00003 20H20V22H4.00003V20Z" fill={accent} />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15 18L17 17L21.6011 20.7645C22.0824 21.1583 22.1185 21.8816 21.6788 22.3213C21.2944 22.7057 20.6803 22.7335 20.2626 22.3855L15 18Z"
        fill={accent}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.00003 8.00019V14.0001L2.74954 15.8759C2.37679 16.435 2.6506 17.1953 3.29425 17.3884L12 20.0001L20.7058 17.3884C21.3495 17.1953 21.6233 16.435 21.2505 15.8759L20 14.0001V8.00007C20 4.6864 17.3138 2.00013 14.0001 2.00012H10.0002C6.68641 2.00012 4.00003 4.68643 4.00003 8.00019ZM10 4.00006C9.44772 4.00006 9 4.44778 9 5.00006C9 5.55235 9.44772 6.00006 10 6.00006H14C14.5523 6.00006 15 5.55235 15 5.00006C15 4.44778 14.5523 4.00006 14 4.00006H10ZM5 15.0001C5 14.4478 5.44772 14.0001 6 14.0001H7C7.55229 14.0001 8 14.4478 8 15.0001C8 15.5523 7.55229 16.0001 7 16.0001H6C5.44772 16.0001 5 15.5523 5 15.0001ZM17 14.0001C16.4477 14.0001 16 14.4478 16 15.0001C16 15.5523 16.4477 16.0001 17 16.0001H18C18.5523 16.0001 19 15.5523 19 15.0001C19 14.4478 18.5523 14.0001 18 14.0001H17ZM6 9.21986C6 8.58882 6.57733 8.11553 7.19612 8.23928L10.1961 8.83928C10.6635 8.93277 11 9.34318 11 9.81986V11.7803C11 12.4113 10.4227 12.8846 9.80389 12.7608L6.80389 12.1608C6.33646 12.0674 6 11.6569 6 11.1803V9.21986ZM13 9.81986C13 9.34318 13.3365 8.93277 13.8039 8.83928L16.8039 8.23928C17.4227 8.11553 18 8.58882 18 9.21986V11.1803C18 11.6569 17.6635 12.0674 17.1961 12.1608L14.1961 12.7608C13.5773 12.8846 13 12.4113 13 11.7803V9.81986Z"
        fill={color}
      />
    </svg>
  );
}

export default IcProductDuotoneTrainFill;
